// extracted by mini-css-extract-plugin
module.exports = {"form-lead__checkbox-lgpd":"FormLead_form-lead__checkbox-lgpd__YWsIK","form-lead__button":"FormLead_form-lead__button__JG7Uo","dropdown":"FormLead_dropdown__u_BI7"};